import { MortgageProductFeeTiming } from '../../../generated/resolvers'
import { ProviderFeeTiming } from './mapToLutherMortgage.fixtures'

export const mapToLutherFeeTiming: { [key in ProviderFeeTiming]: MortgageProductFeeTiming } = {
  [ProviderFeeTiming.UpFront]: MortgageProductFeeTiming.UpFront,
  [ProviderFeeTiming.OnCompletion]: MortgageProductFeeTiming.CompletionTiming,
  [ProviderFeeTiming.OnEarlyRedemption]: MortgageProductFeeTiming.EarlyRedemption,
  [ProviderFeeTiming.OnRedemption]: MortgageProductFeeTiming.Redemption,
}
